(function () {
  const accordion = document.querySelector('.js-tab-accordion');
  if(accordion) {
    const label = document.querySelector('.js-tab-label');
    const list = document.querySelector('.js-shop-list');
    
    let target;
    let targetElement;

    const container = accordion.nextElementSibling;

    accordion.addEventListener('click', open);
    window.addEventListener('resize', () => {
      if (window.matchMedia('(min-width: 960px)').matches) {
        accordion.classList.remove('is-open');
        container.style.maxHeight = '';
        accordion.removeEventListener('click', close);
        accordion.addEventListener('click', open);
      }
    });

    function open() {
      label.textContent = '地域を選択';
      const innerHeight = container.children[0].clientHeight;
      accordion.classList.add('is-open');
      container.style.maxHeight = `${innerHeight}px`;
      accordion.removeEventListener('click', open);
      accordion.addEventListener('click', close);
    }

    function close() {
      accordion.classList.remove('is-open');
      container.style.maxHeight = 0;
      accordion.removeEventListener('click', close);
      accordion.addEventListener('click', open);
    }

  
  }
}());